module.exports = __webpack_public_path__ + "d5a863c8b183b1f8e17ca32c28fa07d4.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SJ.svg
// module id = RZYX
// module chunks = 0